import { Rect } from '../../classes/rect.class';
import { Shape } from '../types/shapes';

const getYMostPoint = (shapes: (Shape | Rect)[], dir: 'top' | 'bottom') => {
  const positions = shapes.map(shape => {
    if (shape instanceof Rect) return shape;
    if (shape.tool === 'polygon') {
      const yPoint = (dir === 'top' ? Math.min : Math.max)(...shape.points.filter((_, i) => i % 2 === 1));
      return new Rect(shape.points[shape.points.indexOf(yPoint) + 1], yPoint);
    }
    if (dir === 'top') {
      if (shape.y1 < shape.y2) return new Rect(shape.x1, shape.y1);
    } else {
      if (shape.y1 > shape.y2) return new Rect(shape.x1, shape.y1);
    }
    return new Rect(shape.x2, shape.y2);
  });
  const yMostPointY = (dir === 'top' ? Math.min : Math.max)(...positions.map(p => p.y));
  return new Rect(positions.find(p => p.y === yMostPointY).x, yMostPointY);
};

const getXMostPoint = (shapes: (Shape | Rect)[], dir: 'left' | 'right') => {
  const positions = shapes.map(shape => {
    if (shape instanceof Rect) return shape;
    if (shape.tool === 'polygon') {
      const xPoint = (dir === 'left' ? Math.min : Math.max)(...shape.points.filter((_, i) => i % 2 === 0));
      return new Rect(xPoint, shape.points[shape.points.indexOf(xPoint) + 1]);
    }
    if (dir === 'left') {
      if (shape.x1 < shape.x2) return new Rect(shape.x1, shape.y1);
    } else {
      if (shape.x1 > shape.x2) return new Rect(shape.x1, shape.y1);
    }
    return new Rect(shape.x2, shape.y2);
  });
  const xMostPointX = (dir === 'left' ? Math.min : Math.max)(...positions.map(p => p.x));
  return new Rect(xMostPointX, positions.find(p => p.x === xMostPointX).y);
};

export const getTopMostPoint = (shapes: (Shape | Rect)[]) => {
  return getYMostPoint(shapes, 'top');
};

export const getBottomMostPoint = (shapes: (Shape | Rect)[]) => {
  return getYMostPoint(shapes, 'bottom');
};

export const getRightMostPoint = (shapes: (Shape | Rect)[]) => {
  return getXMostPoint(shapes, 'right');
};

export const getLeftMostPoint = (shapes: (Shape | Rect)[]) => {
  return getXMostPoint(shapes, 'left');
};

export const getAnnotationBounds = (annotation: (Shape | Rect)[]): Rect => {
  const leftMostPoint = getLeftMostPoint(annotation);
  const rightMostPoint = getRightMostPoint(annotation);
  const topMostPoint = getTopMostPoint(annotation);
  const bottomMostPoint = getBottomMostPoint(annotation);

  return new Rect(
    leftMostPoint.x,
    topMostPoint.y,
    rightMostPoint.x - leftMostPoint.x,
    bottomMostPoint.y - topMostPoint.y
  );
};
